module.exports = __webpack_public_path__ + "static/media/MX.d40ed666.png";